import React from 'react';
import { Task } from '../types/task';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface TaskContextProps {
  tasks: Map<string, Task>;
  setTasks: (tasks: Map<string, Task>) => void;
  tasksLoading: boolean;
}

const defaultContext: TaskContextProps = {
  tasks: new Map(),
  setTasks: () => {},
  tasksLoading: false,
};

export const TaskContext = React.createContext<TaskContextProps>(defaultContext);

interface TaskState {
  items: Record<string, any>[];
  loading: boolean;
}

export const taskSlice = createSlice({
  name: 'task',
  initialState: { items: [], loading: true } as TaskState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    set: (state, action: PayloadAction<Task[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    add: (state, action: PayloadAction<Task[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    delete: (state, action: PayloadAction<Task[]>) => {
      const idsToDelete = new Set(action.payload.map(t => t.id));
      state.items = [...state.items.filter(t => !idsToDelete.has(t.id))];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
